import {
  isNavigationFailure,
  type NavigationFailure,
  type RouteLocationNormalized,
} from "vue-router";

/** The parts of a route location `isPageView` reads. */
export type PageViewLocation = Pick<RouteLocationNormalized, "path"> & {
  matched: readonly unknown[];
};

/**
 * Whether a navigation is a new page view for analytics. A query- or hash-only change on the
 * same path (a tab switch or picker written to the URL with `router.replace`, e.g. the
 * Campaigns page's `?tab=` and `?campaign=`) is the same page, not another view of it.
 * The first navigation always counts: its `from` is the start location, which matches no route.
 * A failed navigation (e.g. the navigation guard's `next(false)`) never rendered `to`, so it
 * isn't a view. (A guard redirect never reaches `afterEach`: only its target does.)
 */
export function isPageView(
  to: PageViewLocation,
  from: PageViewLocation,
  failure?: NavigationFailure | void
): boolean {
  if (isNavigationFailure(failure)) return false;
  return from.matched.length === 0 || to.path !== from.path;
}
